import { useMutation, useQueryClient } from '@tanstack/react-query';
import paymentProvidersApi from '@/features/dashboard/paymentProviders/api/paymentProvidersApi.ts';
import { paymentProvidersApiQueryKeys } from '@/features/dashboard/paymentProviders/api/paymentProvidersApi.queryKeys.ts';
import { toast } from 'sonner';

export default function useRegisterTpay() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (email: string) => paymentProvidersApi.registerTpay(email),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: paymentProvidersApiQueryKeys.status(),
      });
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message || 'Wystąpił błąd podczas rejestracji konta TPay.',
      });
    },
  });
}
